import React, { useState, useEffect } from 'react';
import '../../Stylesheets/Form.css';
import Contact from '../Contacts/ContactInput';
import REInput from '../Contacts/REInput';
import NewLead from '../Contacts/NewLead';
import { useLocation } from 'react-router-dom';
import { useGlobalState } from '../../contexts/GlobalContext';
import { isRealtor } from '../../utils/userAccess';

function Form() {
  const { state } = useGlobalState();
  const canCreateListings = isRealtor(state.user);
  const userId = state.user?.id || ""; // Get user_id from global state
  // Set default state for the form
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    role: 'generic',
    mailAddress: '',
    interestAddress: '',
    budget: '',
    bedrooms: '',
    bathrooms: '',
    propertyType: '',
    offer: '',
    dueDiligence: '',
    daysForClosing: '',
    titleCompany: '',
    escrowAmount: '',
    paymentType: '',
    financeOption: '',
    futureUse: '',
    commission: '',
    sellerA: '',
    sellerB: '',
    time: '',
    term: '',
    creator_id: userId,
  });

  const location = useLocation();
  const prefillContact = location.state?.contact || null;
  
  useEffect(() => {
    if (location.state?.role) {
      setFormData(prevState => ({
        ...prevState,
        role: location.state.role === 're' && !canCreateListings ? 'contact' : location.state.role,
      }));
    }
  }, [location.state, canCreateListings]);

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    if (name === 'role' && value !== 'buyer') {
      setFormData(prevState => ({
        ...prevState,
        role: value
      }));
    } else if (type === 'checkbox') {
      setFormData(prevState => ({
        ...prevState,
        [name]: checked
      }));
    } else if (type === 'select-multiple') {
      const options = event.target.options;
      const selectedOptions = [];
      for (let i = 0; i < options.length; i++) {
        if (options[i].selected) {
          selectedOptions.push(options[i].value);
        }
      }
      setFormData(prevState => ({
        ...prevState,
        [name]: selectedOptions
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  return (
    <div className="container mt-4">
      {/* <div className="mb-3">
        <label htmlFor="role" className="form-label">Select Input Type</label>
        <select
          className="form-control"
          id="role"
          name="role"
          value={formData.role}
          onChange={handleInputChange}
        >
          <option value="">Select</option>
          <option value="contact">Contact</option>
          {canCreateListings && <option value="re">Listing</option>}
        </select>
      </div> */}

      {formData.role === 'contact' && (
        <div>
          <h3>Contact Information</h3>
          <Contact userId={userId} /> 
        </div>
      )}
      {canCreateListings && formData.role === 're' && (
      <div>
        <h3>New Listing</h3>
        <REInput userId={userId} contactPrefill={prefillContact} /> 
      </div>
    )}
  </div>
  );
}

export default Form;
